export const DATE_RANGE_OPTIONS = {
  ALL: 'all',
  TODAY: 'today',
  ONE_WEEK: 'week',
  CUSTOM: 'custom',
} as const;

export const MENU_OFFSET = 4;
